import React, { useContext, useState } from 'react';
import { FilterProps } from '../../common/filter.util';
import { CompanyPartnerFilter } from '../CompanyPartnerFilter';
import { CompanyConnectionContext } from '../../../../../context/CompanyConnectionContext';
import { CompanyConnectionState } from '../../../../../types/companyConnection/companyConnection';
import { CompanyContext } from '../../../../../context/CompanyContext';
import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import { translate } from '../../../../../types/translation/Translator';
import MultiSelectionList from '../../../common/MultiSelectionList';
import { Grid, Divider } from '@mui/material';
import { DeleteIcon } from '../../../../icons/Delete/DeleteIcon';
import SearchBar from '../../../common/SearchBar';
import { VentoryColor } from '../../../../util/color.util';

interface CompanyPartnerFilterDropdownContentProps {
  filter: CompanyPartnerFilter;
  filterProps: FilterProps;
  setFilterProps: (filter: FilterProps) => void;
}

export default function CompanyPartnerFilterDropdownContent({
  filter,
  filterProps,
  setFilterProps,
}: CompanyPartnerFilterDropdownContentProps) {
  const { companyConnections } = useContext(CompanyConnectionContext);
  const { currentCompany, companies } = useContext(CompanyContext);

  const [query, setQuery] = useState<string>('');

  const companyIdsToInclude = new Set([
    currentCompany.id,
    ...[...companyConnections.values()]
      .filter(cc => cc.state === CompanyConnectionState.active)
      .map(cc => cc.companyId),
  ]);

  const values = new Set(
    [...companies.values()]
      .filter(
        company => companyIdsToInclude.has(company.id) && filter.filteredItems([company], query, filterProps).length,
      )
      .map(company => company.id),
  );

  const handleChange = (selected: Set<string>) => {
    filterProps.company = selected;
    if (!filterProps.company?.size) filterProps.company = undefined;
    setFilterProps({ ...filterProps });
  };

  const handleRemove = () => {
    filterProps.company = undefined;
    setFilterProps({ ...filterProps });
  };

  return (
    <Grid container>
      <Grid item xs={12} className='flex px-3 py-2'>
        <Grid container>
          <Grid item>
            <p className='text-[13px] font-[500] text-gray-500'>
              {translate({ key: TranslationKey.partner, count: 'plural' })}
            </p>
          </Grid>
          <Grid item flexGrow={1} display={'flex'} justifyContent={'flex-end'} sx={{ color: VentoryColor.deleteRed }}>
            <Grid item onClick={handleRemove} className='cursor-pointer'>
              <DeleteIcon />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <SearchBar onChange={i => setQuery(i)} className='pl-3 pr-4' />
      </Grid>
      <Grid item className='py-3' xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <MultiSelectionList
          selected={filterProps.company}
          values={values}
          onChange={handleChange}
          toText={id => companies.get(id)?.name}
        />
      </Grid>
    </Grid>
  );
}
